import authRules from '../authRules';

const changeAbsencesResource = (user) => {
  const { changeAbsencesResource } = user.securityLevels;
  if (changeAbsencesResource >= authRules.changeAbsencesResource.changeAbsencesResource) {
      return true;
  } else {
      return false;
    }
  }


export default changeAbsencesResource;



// WEBPACK FOOTER //
// ./src/AuthLogic/rules/changeAbsencesResource.js